define('modules/reporting/campaigns/performance/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  "use strict";

  return ColumnSortable.extend({});
});
